// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const ASSIGN_PATH_DATA = 'ASSIGN_PATH_DATA'
export const PATH_DETAILS_ERROR = 'PATH_DETAILS_ERROR'
export const TOGGLE_PASSIVE_REPEATER_DISPLAY = 'TOGGLE_PASSIVE_REPEATER_DISPLAY'
export const UPDATE_PASSIVE_REPEATER_STORE = 'UPDATE_PASSIVE_REPEATER_STORE'
